import { useEffect } from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { getCafesLoadingStatus, loadCafesList } from "../../store/cafes";
import { getCurrentUserData } from "../../store/users";
import { useI18n } from "../../i18n/LanguageContext";

const CafesLoader = ({ children }) => {
  const { t } = useI18n();
  const dispatch = useDispatch();

  const CafesStatus = useSelector(getCafesLoadingStatus());
  const currentUser = useSelector(getCurrentUserData());
  useEffect(() => {
    if (currentUser?.town) {
      dispatch(loadCafesList({ town: currentUser.town }));
    }
  }, [currentUser]);

  if (CafesStatus) return <div className="text-xl">{t("common.loading")}</div>;
  return children;
};

CafesLoader.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};

export default CafesLoader;
